const DB_USERS = [
    {
        "name": "user1",
        "password": "user1",
        "email": "user1@gmail.com",
        "role": "user",
        "cart": [],
        "orders": [],
        "address": {
            "street": "street1",
            "city": "city1",
            "state": "state1",
            "zip": "zip1"
        },
        "token": "user18911"
    },
    {
        "name": "user2",
        "password": "user2",
        "email": "user2@gmail.com",
        "role": "user",
        "cart": [],
        "orders": [],
        "address": {
            "street": "street2",
            "city": "city2",
            "state": "state2",
            "zip": "zip2"
        },
        "token": "user299811"
    }
];

export default DB_USERS;